export default __webpack_public_path__ + "static/media/ng.bca0a662.svg";